import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { permissionGuard } from '../../../lib/guards/permission.guard';

const guards = [roleGuard('ADMIN_MASTER'), permissionGuard('HOME_SCREEN$READ')];

const listLoader = () =>
  import(
    './components/smart/content-list-page/content-list-page.component'
  ).then((m) => m.ContentListPageComponent);

const detailLoader = () =>
  import(
    './components/smart/homepage-builder-content-detail-page/homepage-builder-content-detail-page.component'
  ).then((m) => m.HomepageBuilderContentDetailPageComponent);

export const homepageBuilderContentRoutes: Routes = [
  {
    path: 'homepage-master/home/content',
    data: { title: 'Homepage Content' },
    canActivate: guards,
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: listLoader,
        children: [
          {
            path: ':id',
            loadComponent: detailLoader,
            data: { title: 'Homepage Content Detail' },
          },
        ],
      },
    ],
  },
];
